import React from 'react';
import Home from '../home/home';
import About from '../about/about';
import Stats from '../stats/Stats';
import Services from '../services/services';
import WhoWeWorkWith from '../whoWeWorkWith/WhoWeWorkWith';
import WhereWeOperate from '../whereWeOperate/WhereWeOperate';
import NctsT1Section from '../NctsT1Section/NctsT1Section';
import FAQ from '../faq/faq';
import CustomsPrice from '../customsPrice/customsPrice';
import News from '../news/News';
import Packages from '../packages/packages';
import Footer from '../footer/footer';

function Helper() {
  return (
    <>
      <Home />
      <About />
      <Stats />
      <Services />
      <WhoWeWorkWith />
      <WhereWeOperate />
      <News />
      <NctsT1Section />
      <FAQ />
      <CustomsPrice />
      <Packages />
      <Footer />
    </>
  );
}

export default Helper;
